import React from 'react';
import PrivateRoute from '../../routes/privateRoute';
// import BillingManagement from "./views/BillingManagement";

const ApiSettings = React.lazy(() => import('./views/ApiSettings'));
// const SubscriptionManagement = React.lazy(() => import('../settings/views/SubscriptionManagement'));
const GeneralSettings = React.lazy(() => import('../settings/views/GeneralSettings'));
const MasterView = React.lazy(() => import('../settings/views/MasterView'));
const MasterData = React.lazy(() => import('../settings/master-data/views/MasterData'));

const settingRoutes = {
    path: '/settings',
    name: 'Settings',
    component: ApiSettings,
    icon: 'dripicons-gear',
    permissions: [{name: ['Setting.General']}, {name: ['MasterView.FullControl']}, {name: ['MasterData.FullControl']}],
    children: [
        {
            path: '/settings/general',
            name: 'General',
            component: GeneralSettings,
            show: true,
            route: PrivateRoute,
            permissions: [{name: ['Setting.General']}],
        },
        {
            path: '/master-view-config',
            name: 'Master View',
            component: MasterView,
            show: true,
            route: PrivateRoute,
            permissions: [{name: ['MasterView.FullControl']}],
        },
        {
            path: '/master-data',
            name: 'Master Data',
            component: MasterData,
            show: true,
            route: PrivateRoute,
            permissions: [{name: ['MasterData.FullControl']}],
        },
        // {
        //     path: '/settings/api',
        //     name: 'API',
        //     component: ApiSettings,
        //     show: true,
        //     route: PrivateRoute,
        //     permissions: [{name: ['User.FullControl']}],
        // },
        // {
        //     path: '/subscriptions',
        //     name: 'Subscriptions',
        //     component: SubscriptionManagement,
        //     show: true,
        //     route: PrivateRoute,
        //     permissions: [{name: ['Billing.ReadOnly']}],
        // },
        // {
        //     path: '/billing',
        //     name: 'Billing',
        //     component: BillingManagement,
        //     show: true,
        //     route: PrivateRoute,
        //     permissions: [{name: ['Billing.ReadOnly']}],
        // },
    ],
};

export default settingRoutes;
